const MONTHLY = 'monthly';
const ANNUAL = 'annual';
const ONCE = 'once';
export const validateTermOrGetDefault = term => {
  var _find;
  return (_find = [MONTHLY, ANNUAL, ONCE].find(validTerm => validTerm === term.toLowerCase())) !== null && _find !== void 0 ? _find : ANNUAL;
};
export const validateRecurringTermOrGetDefault = term => {
  var _find2;
  return (_find2 = [MONTHLY, ANNUAL].find(validTerm => validTerm === term.toLowerCase())) !== null && _find2 !== void 0 ? _find2 : ANNUAL;
};